import { httpApi, httpApiArtifi } from "api/http.api";
import { AxiosError, AxiosResponse } from "axios";
import {
  DeleteProductsBody,
  ProductListBody,
  RenameProductsBody,
  SelectedCustomProducts,
  artifiPayloadDetails,
} from "interfaces/ApiInterface/IProductGroupList";
import { getUserData } from "utils";

export const associateProduct = (portalId: number, PublishCatalogId: number) => {
  const url = `rawlingsmylocker/getassociatedproducts/${portalId}/${PublishCatalogId}`;
  return httpApi
    .get(url)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

/* Getting the "Group Names List" for filter option to get filtered product list */
export const getProductGroupNamesService = (userId: number) => {
  const url: string = "/rawlingsmylocker/getgroupsbyuserid/" + userId;
  return httpApi
    .get(url)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

/* Getting the product list of "My Collection" when we select group name from filter */
export const getProductsByDesignId = async (
  selectedProducts: SelectedCustomProducts[],
  userId: number,
  publishCatalogId: number
) => {
  const body = {
    customProducts: selectedProducts,
    userId: userId || 0,
    publishCatalogId: publishCatalogId || 0,
  };
  const url = "/rawlingsmylocker/GetCustomizedProductsByDesignIds";
  return httpApi
    .post(url, body)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

/* Getting the product list of "My Collection" when we select group name from filter */
export const getProductsService = async (
  groupName: string,
  publishCatalogId: number,
  pageNumber?: number
) => {
  const userData = getUserData();
  const body: ProductListBody = {
    userId: userData?.UserId,
    groupName: groupName,
    publishCatalogId: publishCatalogId,
    pageNumber: pageNumber || 0,
  };
  const url = "/rawlingsmylocker/GetCustomizedProductsByGroup";
  return httpApi
    .post(url, body)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

/* delete products by selection */
export const deleteProductService = (body: DeleteProductsBody) => {
  const url = "/rawlingsmylocker/deleteproductcustomizationdetails";
  return httpApi
    .post(url, body)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

export const deleteProductServiceFromArtifi = (url: string) => {
  return httpApiArtifi
    .delete(url)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

/* rename products configuration name */
export const renameProductConfigurationNameService = (
  productId: number,
  configurationName: string,
  groupName: string
) => {
  const reqBody: RenameProductsBody = {
    UserId: getUserData()?.UserID,
    ProductCustomizationDetailsId: productId,
    ConfigurationName: configurationName,
    GroupName: groupName,
  };
  const url = "/rawlingsmylocker/updateconfigurationname";
  return httpApi
    .put(url, reqBody)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

//artifi related Apis
export const getrawlingsartificonfigurationdata = (portalId: number) => {
  return httpApi
    .get(`rawlingsportal/getrawlingsartificonfigurationdata/${portalId}`)
    .then((response: AxiosResponse) => response)
    .catch((err: AxiosError) => {
      throw err;
    });
};

//artifi save related APIs
export const saveArtifiDetails = (data: artifiPayloadDetails) => {
  const url = "rawlingsmylocker/AddOrUpdateProductCustomizationDetails";
  return httpApi
    .post(url, data)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

export const updateUserIdInArtifi = (url: string) => {
  return httpApiArtifi.put(url, {});
};

export const createCaptureDesign = (guid: string) => {
  const url = `/rawlingsmylocker/createcapturedesign?guid=${guid}`;
  return httpApi.post(url, {});
};

export const getCaptureDesign = (guid: string) => {
  const url = `/rawlingsmylocker/getcapturedesign/${guid}`;
  return httpApi.get(url);
};
